import type { FaireProductEntity } from "../../entity_types/product";

export const p_2t3yx3mukt: FaireProductEntity = {
  token: "p_2t3yx3mukt",
  type: "product",
  name: "Raw Crunch® - Organic Mixed Box - 12 bars",
  brandToken: "b_5a58cvuhsd",
  brandName: "Raw Crunch®",
  imageUrl:
    "https://cdn.faire.com/fastly/eb41799dbb03f1d9d6ed98dcba90e129810141b61042300a5fbf16132160d89e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/942d945267f9147c062dc5dbeef70192688da6990a5765149fcd7afc7ecdc734.jpeg",
    "https://cdn.faire.com/fastly/84e4d53273de00e64f40395670c7c07a6c3dc66edeea66c0caba7420ab54a290.jpeg",
  ],
  priceDollars: 34.36,
  description:
    'Raw, Organic, Gluten Free, Dairy Free, Soy Free, Low Carb, Paleo, Plant Based Protein, 150 Calorie Real Food Bar.\n\nCRUNCH-A-LICIOUS - A little crunchy, a little chewy and the perfect balance of sweet and salty! \n\nNUTRITIONALLY SATISFYING - For only 150 calories, 7g net carbs, 5g sugar and 60mg sodium, you\'ll up your energy like crazy, curb your cravings & stay nice.\n\nAS CLEAN AS IT GETS - Raw, organic, gluten free, grain free, dairy free, soy free, low carb & low sugar. NO "natural" flavors or artificial sweeteners!\n\nNATURE UNCHANGED - Soaked & dehydrated, rather than cooked, in order to maintain their original concentrated nutrients and enzymes.\n\nSMALL BATCHES - Handmade in small batches from the highest quality, ethically sourced, organic, non-GMO ingredients in our own North Carolina facility since 2003.\n\nBox includes 12 assorted bars.\n',
  tags: [],
  msrpDollars: 46.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:30.767Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
